
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import HinaInput from "@/views/ai-builder-component/baseComponent/hina-input.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import { ElForm } from "element-ui/types/form";

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard,
    HinaSwitch,
    HinaInput
  }
})
export default class FaceCheck extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  get livenessRecognition() {
    return this.formItemData.livenessRecognition;
  }

  get nameIdCheck() {
    return this.formItemData.nameIdCheck;
  }

  handleUse(newVal: number) {
    const used = newVal === 1;
    if (used) {
      console.log("🚀 ~ FaceCheck ~ handleUse ~ used:", used);
      this.formItemData.params.use = 1;
      this.formItemData.allParams.forEach(item => {
        if (!["姓名", "手机", "身份证号"].includes(item.name)) return;

        const select = this.formItemData.paramList.find(
          sItem => sItem.name === item.name
        );

        if (select) {
          // 开启背调，不需要开启验证码，因为登录的时候已经输入验证码了
          select.captchaCheck = 0;
          select.isRequired = 1;
          select.isShow = 1;
          select.saveLater = 0;
          select.showConfigList = [];
          return;
        }
      });
    }
  }

  rules = {
    maxSubmitNumber: [
      {
        required: true,
        message: "请输入验证次数",
        type: "number",
        trigger: "blur"
      }
    ],
    noticeMessage: [
      { required: true, message: "请输入失败文案", trigger: "blur" }
    ]
  };

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck() {
    return new Promise((resolve, reject) => {
      console.log(this.$refs.formRef);
      if (this.$refs.formRef) {
        (this.$refs.formRef as ElForm)
          .validate()
          .then(() => resolve(""))
          .catch(() => resolve("aiWatchingPolice"));
      } else {
        resolve("");
      }
    });
  }
}
